import { useRecoilState, useSetRecoilState } from "recoil";
import {
  current,
  mobileCurrentPage,
  pageState,
  pdfPage,
  pdfRef,
  scaleValue,
} from "../atoms";
import { useCallback, useEffect, useState } from "react";
import { IconButton, TextField, Tooltip, useMediaQuery } from "@mui/material";

import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import styled from "styled-components";

const ControllBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

function PageButton() {
  const [bookRef, setBookRef] = useRecoilState(pdfRef);
  const [pageStates, setPageState] = useRecoilState(pageState);
  const [numPages, setNumPages] = useRecoilState(pdfPage);
  const [inputValue, setInputValue] = useState(1);
  const [zoomValue, setZoomValue] = useRecoilState(scaleValue);
  const [mobilePage, setMobilePage] = useRecoilState(mobileCurrentPage);

  const isMobile = useMediaQuery("(max-width: 768px)");

  useEffect(() => {
    setInputValue(pageStates.currentPage);
  }, [pageStates.currentPage]);

  const goToNextPage = (e) => {
    if (bookRef) {
      e.currentTarget.blur();
      bookRef.pageFlip().flipNext();
    }
  };
  const goToNextPageMobil = () => {
    setMobilePage((prev) => prev + 1);
  };
  const goToPreviousPage = (e) => {
    if (bookRef) {
      e.currentTarget.blur();
      bookRef.pageFlip().flipPrev();
    }
  };
  const goToHome = () => {
    if (bookRef) {
      bookRef.pageFlip().flip(0);
    }
  };
  const goToEnd = () => {
    if (bookRef) {
      bookRef.pageFlip().flip(numPages - 1);
    }
  };

  const handleKeyPageMove = useCallback(
    (e) => {
      if (e.key === "ArrowRight") {
        e.preventDefault();
        goToNextPage(e);
      } else if (e.key === "ArrowLeft") {
        e.preventDefault();
        goToPreviousPage(e);
      }
    },
    [goToNextPage, goToPreviousPage]
  );

  useEffect(() => {
    window.addEventListener("keydown", handleKeyPageMove);
    return () => {
      window.removeEventListener("keydown", handleKeyPageMove);
    };
  }, [handleKeyPageMove]);

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // 엔터키 눌렀을 때 새로고침 방지
      const stringToNumber = Number(inputValue);
      if (stringToNumber === 0 || stringToNumber < 0) {
        alert("첫페이지로 이동합니다.");
        bookRef.pageFlip().flip(0);
        setInputValue(1);
        return;
      }
      if (stringToNumber > numPages) {
        alert(`마지막 페이지는 ${numPages}입니다.`);
        bookRef.pageFlip().flip(numPages - 1);
        setInputValue(numPages);
        return;
      }
      if (
        stringToNumber % 2 !== 0 &&
        stringToNumber !== 1 &&
        stringToNumber !== numPages
      ) {
        bookRef.pageFlip().flip(stringToNumber - 2);
      } else {
        bookRef.pageFlip().flip(stringToNumber - 1);
      }
    }
  };
  return (
    <ControllBox>
      <Tooltip title="Home" color="primary" onClick={goToHome}>
        <IconButton disabled={inputValue <= 1} sx={{ marginRight: 2 }}>
          <KeyboardDoubleArrowLeftIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="Prev" color="primary" onClick={goToPreviousPage}>
        <IconButton disabled={inputValue <= 1} sx={{ marginRight: 2 }}>
          <KeyboardArrowLeftIcon />
        </IconButton>
      </Tooltip>
      {/* <button onClick={goToHome}>Home</button>
        <button onClick={goToPreviousPage} disabled={inputValue <= 1}>
          Previous
        </button> */}
      <TextField
        id="outlined-number"
        label="Page"
        type="number"
        size="small"
        value={inputValue}
        onKeyDown={handleKeyDown} // 엔터키 이벤트를 처리
        onChange={(e) => setInputValue(e.target.value)}
        sx={{ width: "70px", marginRight: 1 }}
      />
      {/* <input
          type="text"
          value={inputValue}
          onKeyDown={handleKeyDown} // 엔터키 이벤트를 처리
          onChange={(e) => setInputValue(e.target.value)}
        /> */}
      <span> / </span>
      <span style={{ marginRight: "20px", marginLeft: "10px" }}>
        {numPages}
      </span>
      <Tooltip title="Next" color="primary" onClick={goToNextPage}>
        <IconButton
          disabled={inputValue >= numPages - 1}
          sx={{ marginRight: 2 }}
          disableFocusRipple
        >
          <KeyboardArrowRightIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="End" color="primary" onClick={goToEnd}>
        <IconButton disabled={inputValue >= numPages - 1}>
          <KeyboardDoubleArrowRightIcon />
        </IconButton>
      </Tooltip>
      {/* <button onClick={goToNextPage}>Next</button>
        <button onClick={goToEnd}>End</button> */}
    </ControllBox>
  );
}

export default PageButton;
